import { useCallback, useEffect, useState } from 'react';
import { GROUP_ELEMENT_ID_PREFIX, NEW_GROUP_ID } from '../../common/constants';
import { useActionsProvider } from '../../services/store';

const scrollToTemplate = () => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const templateElement = document.getElementById(`${GROUP_ELEMENT_ID_PREFIX}${NEW_GROUP_ID}`);
	templateElement && templateElement.scrollIntoView({ block: 'end', behavior: 'smooth' });
};

const useAddGroupTemplate = () => {
	const { createTemplate } = useActionsProvider();
	const [hasScrolled, setScrolled] = useState<unknown>(null);

	// Scroll to element after render has completed
	useEffect(() => {
		if (hasScrolled === false) {
			scrollToTemplate();
			setScrolled(true);
		}
	}, [hasScrolled]);

	return useCallback(() => {
		createTemplate((hasTemplate) => {
			if (hasTemplate === true) {
				scrollToTemplate();
			}
			setScrolled(Boolean(hasTemplate));
		});
	}, [createTemplate]);
};

export default useAddGroupTemplate;
